import { PolicyResource } from "@vmosolutions/oc-interfaces";
import { ITableColumn } from "src/components/FilterSearchTable/TableComponents/TableHeader";

//interface IExtendedCrewBid {
//  bidId: string;
//  nfaBids: 0;
//  pairingBids: 0;
//  userId: string;
//  crewMember: ICrewMember;
//  status: "removed"|"nochange"|"added" // property added to table data in order to show crew changes that will take place is crew is rebuilt using selected groups.
//}

// PAIRINGS
export const bidCrewTableDesc = {
  tableTitle: "",
  tableDescription: "",
  noMessage: "No bid crew to display, select crew groups to add.",
};
export const bidCrewTableInfo: ITableColumn[] = [
  {
    id: "userId",
    value: "userId",
    index: 0,
    numeric: false,
    label: "User Id",
    type: "string",
    width: 10,
    visible: false,
    filter: false,
    sort: false,
  },
  {
    id: "crewMember[firstName]",
    value: "firstName[firstName]",
    index: 1,
    numeric: false,
    label: "First Name",
    type: "string",
    width: 10,
    visible: true,
    filter: false,
    sort: true,
  },
  {
    id: "crewMember[lastName]",
    value: "crewMember[lastName]",
    index: 2,
    numeric: false,
    label: "Last Name",
    type: "string",
    width: 10,
    visible: true,
    filter: false,
    sort: true,
  },
  {
    id: "nfaBids",
    value: "nfaBids",
    index: 3,
    numeric: true,
    label: "NFA Bids",
    type: "number",
    width: 10,
    visible: true,
    filter: false,
    sort: true,
  },
  {
    id: "pairingBids",
    value: "pairingBids",
    index: 4,
    numeric: true,
    label: "Pairing Bids",
    type: "number",
    width: 10,
    visible: true,
    filter: false,
    sort: true,
  },
  {
    id: "crewMember[crewInfo][groups]",
    value: "crewMember[crewInfo][groups]",
    index: 5,
    numeric: false,
    label: "Group Membership",
    type: "array",
    width: 10,
    visible: true,
    filter: false,
    sort: true,
  },
  {
    id: "crewMember[crewInfo][isActive]",
    value: "crewMember[crewInfo][isActive]",
    index: 6,
    numeric: false,
    label: "Active Status",
    type: "boolean",
    width: 10,
    visible: true,
    filter: false,
    sort: true,
  },
  {
    id: "status",
    value: "status",
    index: 7,
    numeric: false,
    label: "Package Status",
    type: "string",
    width: 10,
    visible: true,
    filter: false,
    sort: true,
  },
];

export interface ITableData {
  id: string;
  dataType: string;
  label: string;
  permissionResource: PolicyResource;
  data: any[];
  tableInfo: ITableColumn[];
  tableInfoDisplay: {
    tableTitle: string;
    tableDescription: string;
    noMessage: string;
  };
}
// Function used to create the dataSet needed for the table component.
// This particular dataSet contains an array with all the available data types for the advanced search functionality.
export const tableData: ITableData[] = [
  {
    id: "bidPackageCrew",
    dataType: "bidPackageCrew",
    label: "Bid Package Crew",
    permissionResource: PolicyResource.Bidding,
    data: [],
    tableInfo: bidCrewTableInfo,
    tableInfoDisplay: bidCrewTableDesc,
  },
];
